<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5csEgx/tc-custom/9781910859513.jpg?1701542857862" alt="This image is the cover for the book Icon of Gold"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Icon of Gold
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A searing tale of </b><b>forbidden love spanning </b><b>1950s Britain and Greece from the author of <i>A Fragile Peace</i>, </b><b>“a wonderful storyteller” (</b><b><i>Daily Mail</i>).</b><br/>  <br/> Cathy Kotsikas is as unsettled as anyone in postwar Britain. A hasty marriage has become an exhausting clash of personalities. Leon, her Greek husband, as charming as he is ruthless and self-centered, understands neither her mildly eccentric character nor her need for freedom.<br/> Cathy’s sanctuary is Sandlings, a remote cottage on the barren Suffolk coast left to her by her grandfather. For Leon, however, his business in London and the restoration of his family home in Greece are of paramount importance.<br/>  <br/> When Nikos, Leon’s son, arrives from New York, he is drawn to Cathy from the first, and she to him. Neither sees the danger of the attraction until it is too late. Their chemistry becomes a spiral of passion and betrayal culminating in the wild sunlit beauty of the Greek countryside. But how will it end . . . ?<br/>  <br/><b>“A story with great momentum and the added attraction of inviting backdrops in sunlit Greece and a remote seascape in Suffolk.” —<i>Liverpool Echo</i></b><br/>  <br/><b>“A writer of great skill and vitality.” —Sarah Harrison, international bestselling author of <i>The Flowers of the Field</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Teresa Crane
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57f786d2